import React, { useCallback } from "react";
import classNames from "classnames";
import { Transaction } from "@common/types/transaction";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { MatchingTransaction } from "./MatchingTransaction";
import styles from "./RuleTransactionsPreview.module.scss";

interface Props {
    transaction: Transaction;
    pairedTransaction: Transaction;
    isChecked: boolean;
    isDisabled: boolean;
    toggle: (transaction: Transaction) => void;
}

export const MatchingPair: React.FC<Props> = ({
    transaction,
    pairedTransaction,
    isDisabled,
    isChecked,
    toggle,
}) => {
    const handleClick = useCallback(() => {
        toggle(transaction);
    }, [toggle, transaction]);

    return (
        <div className={styles.pairContainer} onClick={handleClick}>
            <div
                className={styles.checkboxColumn}
                onClick={(event) => event.stopPropagation()}
            >
                <Checkbox
                    checked={isChecked}
                    onCheckedChange={handleClick}
                    disabled={isDisabled}
                />
            </div>
            <div className={styles.transactionsPair}>
                <div
                    className={classNames(styles.transactionRow, {
                        [styles.deselected]: !isChecked || isDisabled,
                    })}
                >
                    <MatchingTransaction transaction={transaction} />
                </div>
                <div
                    className={classNames(styles.transactionRow, {
                        [styles.deselected]: !isChecked || isDisabled,
                    })}
                >
                    <MatchingTransaction transaction={pairedTransaction} />
                </div>
            </div>
        </div>
    );
};
